import { useContext } from 'react';
import checkoutContext from '../checkout.context';

const useCheckoutContext = () => useContext(checkoutContext);

export default useCheckoutContext;
